(function ($) {
  Drupal.behaviors.discover_more = {
    attach: function (context, settings) {
      // discover more
      if (page_data['catalog-spp-workswith'] !== undefined) {
        var worksWithData = page_data['catalog-spp-workswith'].products;
        var $btn_quickshop = $('.discover_more__product-quickshop', context);

        $btn_quickshop.off('click').on('click', function (e) {
          e.preventDefault();
          console.log('quickshop initiated!');
          var quickshopPID = $(this).attr('data-productid');
          var quickshopData = _.find(worksWithData, function (pr) {
            return pr.PRODUCT_ID == quickshopPID;
          });

          site.quickshop(quickshopData);
        });
      }
    }// attach
  };
})(jQuery);
